<!-- ============================================================ -->
<!-- DESKTOP VIEW (md y superior) — layout original con tablas   -->
<!-- ============================================================ -->
<div class="hidden md:block p-6 min-h-screen" style="zoom: 0.9">
  <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
    <h3 class="font-bold">{{ '::Coupons' | abpLocalization }}</h3>
    <div class="flex gap-2">
      @if (activeTab === 'list' && isAdmin) {
      <app-metro-button variant="outline" text="{{ '::CheckCouponsNow' | abpLocalization }}"
        (clicked)="checkCouponsStatus()" [loading]="isCheckingStatus">
      </app-metro-button>
      }
      @if (activeTab === 'list') {
      <app-metro-button variant="secondary" text="{{ '::AddCoupon' | abpLocalization }}" (clicked)="openCreateModal()">
      </app-metro-button>
      }
      @if (activeTab === 'report') {
      <app-metro-button variant="secondary" text="" [icon]="excelIcon" [iconSize]="'18'" [iconColor]="'#1C2D36'"
        [loading]="isExporting" (clicked)="exportCsv()">
      </app-metro-button>
      }
    </div>
  </div>

  <!-- Tabs -->
  <div class="flex border-b border-gray-200 mb-6">
    <button (click)="setTab('list')"
      [ngClass]="activeTab === 'list' ? 'border-metro-blue text-metro-blue' : 'border-transparent text-gray-500 hover:text-gray-700'"
      class="py-2 px-6 border-b-2 font-medium text-sm transition-all duration-300">
      {{ '::List' | abpLocalization }}
    </button>
    <button (click)="setTab('report')"
      [ngClass]="activeTab === 'report' ? 'border-metro-blue text-metro-blue' : 'border-transparent text-gray-500 hover:text-gray-700'"
      class="py-2 px-6 border-b-2 font-medium text-sm transition-all duration-300">
      {{ '::Report' | abpLocalization }}
    </button>
  </div>

  <!-- Filters Section -->
  <div class="flex flex-col md:flex-row gap-2 mb-8 items-center">
    <div [class]="activeTab === 'list' ? 'flex-[2]' : 'flex-1'"
      class="w-full [&_input]:uppercase [&_input::placeholder]:normal-case mb-1">
      <app-metro-search-input (search)="onSearch($event)" (cleared)="onClearSearch()"></app-metro-search-input>
    </div>

    <!-- Filtros List -->
    @if (activeTab === 'list') {
    <div class="flex-1 w-full relative top-[4px] mt-0">
      <app-metro-form-select [placeholder]="'::Status' | abpLocalization" label="" [options]="statusOptions"
        [ngModel]="searchCoupons.status" (selectionChange)="searchCoupons.status = $event; onFilterChange()">
      </app-metro-form-select>
    </div>
    <div class="flex-1 w-full relative top-[4px]">
      <app-metro-form-select [placeholder]="'::Sommelier' | abpLocalization" label="" [options]="sommelierOptions"
        [ngModel]="searchCoupons.sommelierId" (selectionChange)="searchCoupons.sommelierId = $event; onFilterChange()">
      </app-metro-form-select>
    </div>
    <div class="flex-1 w-full relative top-[4px]">
      <app-metro-form-select [placeholder]="'::DiscountType' | abpLocalization" label="" [options]="typeOptions"
        [ngModel]="searchCoupons.discountType"
        (selectionChange)="searchCoupons.discountType = $event; onFilterChange()">
      </app-metro-form-select>
    </div>
    }

    <!-- Filtros Report -->
    @if (activeTab === 'report') {
    <div class="flex-1 w-full">
      <app-metro-form-input [placeholder]="'::FromDate' | abpLocalization" label="" type="date"
        [ngModel]="reportFilter.fromDate" (ngModelChange)="reportFilter.fromDate = $event; onFilterChange()">
      </app-metro-form-input>
    </div>
    <div class="flex-1 w-full">
      <app-metro-form-input [placeholder]="'::ToDate' | abpLocalization" label="" type="date"
        [ngModel]="reportFilter.toDate" (ngModelChange)="reportFilter.toDate = $event; onFilterChange()">
      </app-metro-form-input>
    </div>
    <div class="flex-1 w-full relative top-[4px]">
      <app-metro-form-select [placeholder]="'::Sommelier' | abpLocalization" label="" [options]="sommelierOptions"
        [ngModel]="reportFilter.sommelierId" (selectionChange)="reportFilter.sommelierId = $event; onFilterChange()">
      </app-metro-form-select>
    </div>
    }
  </div>

  <!-- Table Section -->
  <div class="overflow-x-auto w-full min-w-0">
    @if (isLoading) {
    <div class="p-8">
      <app-metro-table-skeleton [columns]="activeTab === 'list' ? columns : reportColumns"></app-metro-table-skeleton>
    </div>
    } @else {
    @if (activeTab === 'list') {
    <app-metro-table [columns]="columns" [data]="data.items" [actions]="actions" [pageSize]="maxResultCount"
      [(currentPage)]="currentPage" (pageChange)="onPageChange($event)" [isServerPaginated]="true"
      [totalItems]="data.totalCount">
    </app-metro-table>
    }
    @if (activeTab === 'report') {
    <app-metro-table [columns]="reportColumns" [data]="reportData" [pageSize]="100" [totalItems]="reportData.length">
    </app-metro-table>
    }
    }
  </div>
</div>


<!-- ============================================================ -->
<!-- MOBILE VIEW (menos de md) — layout con tarjetas              -->
<!-- ============================================================ -->
<div class="md:hidden min-h-screen px-4 pt-6 pb-24 overflow-x-hidden" style="zoom: 0.9">

  <!-- Header -->
  <div class="mb-5">
    <h3 class="font-bold mb-2">{{ '::Coupons' | abpLocalization }}</h3>
    <div class="flex items-center gap-2">
      @if (activeTab === 'list' && isAdmin) {
      <button (click)="checkCouponsStatus()" [disabled]="isCheckingStatus"
        class="text-sm text-gray-500 disabled:opacity-50 whitespace-nowrap">
        {{ '::CheckCouponsNow' | abpLocalization }}
      </button>
      }
      @if (activeTab === 'list') {
      <button (click)="openCreateModal()"
        class="px-3 py-2 border border-gray-300 bg-white rounded-xl text-sm font-semibold text-gray-800 whitespace-nowrap">
        {{ '::AddCoupon' | abpLocalization }}
      </button>
      }
      @if (activeTab === 'report') {
      <button (click)="exportCsv()" [disabled]="isExporting"
        class="px-3 py-2 border border-gray-300 bg-white rounded-xl text-sm font-semibold text-gray-800 whitespace-nowrap flex items-center gap-2">
        @if (isExporting) {
        <span class="animate-spin h-4 w-4 border-2 border-gray-500 border-t-transparent rounded-full"></span>
        }
        {{ (isExporting ? '::Exporting' : '::ExportCSV') | abpLocalization }}
      </button>
      }
    </div>
  </div>

  <!-- Tabs -->
  <div class="flex border-b border-gray-200 mb-5">
    <button (click)="setTab('list')"
      [class]="activeTab === 'list' ? 'border-b-2 border-gray-900 text-gray-900 font-semibold' : 'text-gray-400 font-medium'"
      class="py-2 pr-6 text-sm transition-all">
      {{ '::List' | abpLocalization }}
    </button>
    <button (click)="setTab('report')"
      [class]="activeTab === 'report' ? 'border-b-2 border-gray-900 text-gray-900 font-semibold' : 'text-gray-400 font-medium'"
      class="py-2 px-6 text-sm transition-all">
      {{ '::Report' | abpLocalization }}
    </button>
  </div>

  <!-- Search -->
  <div class="relative mb-3">
    <div class="absolute inset-y-0 left-4 flex items-center pointer-events-none">
      <svg class="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z" />
      </svg>
    </div>
    <input type="text" [placeholder]="'::Search' | abpLocalization" (input)="onSearch($any($event.target).value)"
      class="w-full pl-11 pr-4 py-3 bg-gray-100 rounded-2xl text-sm font-medium text-gray-800 placeholder:text-gray-400 border-0 focus:outline-none focus:ring-2 focus:ring-gray-200 uppercase" />
  </div>

  <!-- List Filters -->
  @if (activeTab === 'list') {
  <div class="flex flex-col gap-2 mb-6">
    <app-metro-form-select [placeholder]="'::Status' | abpLocalization" label="" [options]="statusOptions"
      [ngModel]="searchCoupons.status" (selectionChange)="searchCoupons.status = $event; onFilterChange()">
    </app-metro-form-select>
    <app-metro-form-select [placeholder]="'::Sommelier' | abpLocalization" label="" [options]="sommelierOptions"
      [ngModel]="searchCoupons.sommelierId" (selectionChange)="searchCoupons.sommelierId = $event; onFilterChange()">
    </app-metro-form-select>
    <app-metro-form-select [placeholder]="'::DiscountType' | abpLocalization" label="" [options]="typeOptions"
      [ngModel]="searchCoupons.discountType" (selectionChange)="searchCoupons.discountType = $event; onFilterChange()">
    </app-metro-form-select>
  </div>
  }

  <!-- Report Filters -->
  @if (activeTab === 'report') {
  <div class="flex flex-col gap-2 mb-6">
    <app-metro-form-input [placeholder]="'::FromDate' | abpLocalization" label="" type="date"
      [ngModel]="reportFilter.fromDate" (ngModelChange)="reportFilter.fromDate = $event; onFilterChange()">
    </app-metro-form-input>
    <app-metro-form-input [placeholder]="'::ToDate' | abpLocalization" label="" type="date"
      [ngModel]="reportFilter.toDate" (ngModelChange)="reportFilter.toDate = $event; onFilterChange()">
    </app-metro-form-input>
    <app-metro-form-select [placeholder]="'::Sommelier' | abpLocalization" label="" [options]="sommelierOptions"
      [ngModel]="reportFilter.sommelierId" (selectionChange)="reportFilter.sommelierId = $event; onFilterChange()">
    </app-metro-form-select>
  </div>
  }

  <!-- List Cards -->
  @if (activeTab === 'list') {
  @if (isLoading) {
  <div class="space-y-4">
    @for (i of [1,2,3]; track i) {
    <div class="h-40 bg-gray-100 rounded-2xl animate-pulse"></div>
    }
  </div>
  } @else {
  <div class="space-y-4">
    @for (item of data.items; track item.id) {
    <div class="border border-gray-200 rounded-2xl overflow-hidden bg-white shadow-sm">

      <div class="px-4 py-4">
        <!-- Fila 1: Código | Tipo | Valor | Usos -->
        <div class="grid grid-cols-3 gap-x-2 mb-4">
          <div class="min-w-0">
            <p class="text-[10px] text-gray-400 mb-0.5">{{ '::Code' | abpLocalization }}</p>
            <p class="text-sm font-bold text-gray-900 truncate">{{ item.code }}</p>
          </div>
          <div class="min-w-0">
            <p class="text-[10px] text-gray-400 mb-0.5">{{ '::Value' | abpLocalization }}</p>
            <p class="text-sm font-semibold text-gray-800 truncate">{{ item.discountValueDisplay }}</p>
          </div>
          <div class="min-w-0">
            <p class="text-[10px] text-gray-400 mb-0.5">{{ '::Uses' | abpLocalization }}</p>
            <p class="text-sm font-semibold text-gray-800 truncate">{{ item.uses }}</p>
          </div>
        </div>

        <!-- Fila 2: Fechas | Estado | Sommelier | Activo -->
        <div class="grid grid-cols-2 gap-4 mb-4">
          <div class="min-w-0">
            <p class="text-[10px] text-gray-400 mb-0.5">{{ '::StartDate' | abpLocalization }}</p>
            <p class="text-[11px] font-semibold text-gray-700 leading-snug">{{ item.startDateDisplay }}</p>
          </div>
          <div class="min-w-0">
            <p class="text-[10px] text-gray-400 mb-0.5">{{ '::EndDate' | abpLocalization }}</p>
            <p class="text-[11px] font-semibold text-gray-700 leading-snug">{{ item.endDateDisplay }}</p>
          </div>
        </div>

        <div class="grid grid-cols-2 gap-4">
          <div class="min-w-0 overflow-hidden">
            <p class="text-[10px] text-gray-400 mb-1">{{ '::Status' | abpLocalization }}</p>
            <span [class]="getStatusBadgeClass(item.status)"
              class="inline-block px-2 py-0.5 rounded-full text-[10px] font-bold max-w-full">
              {{ getStatusLabel(item.status) }}
            </span>
          </div>
          <div class="min-w-0">
            <p class="text-[10px] text-gray-400 mb-0.5">{{ '::Sommelier' | abpLocalization }}</p>
            <p class="text-[11px] font-semibold text-gray-700 truncate leading-snug">{{ item.sommelierName }}</p>
          </div>
        </div>
      </div>

      <!-- Action Bar -->
      <div class="border-t border-gray-100 grid grid-cols-2 divide-x divide-y divide-gray-100">
        <button (click)="openViewModal(item)"
          class="flex items-center justify-center gap-1.5 py-2 text-[12px] font-medium text-gray-600 hover:bg-gray-50 transition-colors">
          <svg class="w-3.5 h-3.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          {{ '::View' | abpLocalization }}
        </button>
        <button (click)="openEditModal(item)"
          class="flex items-center justify-center gap-1.5 py-2 text-[12px] font-medium text-gray-600 hover:bg-gray-50 transition-colors">
          <svg class="w-3.5 h-3.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
          {{ '::Edit' | abpLocalization }}
        </button>
        <button (click)="toggleActive(item)"
          class="flex items-center justify-center gap-1.5 py-2 text-[12px] font-medium text-gray-600 hover:bg-gray-50 transition-colors col-span-2">
          <svg class="w-3.5 h-3.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10" />
            <line x1="8" y1="12" x2="16" y2="12" stroke-linecap="round" />
          </svg>
          {{ item.isActive ? ('::Deactivate' | abpLocalization) : ('::Activate' | abpLocalization) }}
        </button>
      </div>
    </div>
    }
  </div>

  <!-- Pagination -->
  <div class="mt-6 flex items-center justify-between">
    <span class="text-sm font-semibold text-blue-500">{{ data.totalCount }} {{ '::Total' | abpLocalization }}</span>
    <div class="flex items-center gap-1">
      <button (click)="onPageChange(1)" [disabled]="currentPage === 1"
        class="w-8 h-8 flex items-center justify-center rounded-lg text-xs text-gray-400 disabled:opacity-30">«</button>
      <button (click)="onPageChange(currentPage - 1)" [disabled]="currentPage === 1"
        class="w-8 h-8 flex items-center justify-center rounded-lg text-xs text-gray-400 disabled:opacity-30">‹</button>
      @for (p of getPageNumbers(); track p) {
      <button (click)="onPageChange(p)"
        [class]="currentPage === p ? 'bg-gray-900 text-white font-bold' : 'text-gray-500 font-medium'"
        class="w-8 h-8 flex items-center justify-center rounded-lg text-sm transition-all">
        {{ p }}
      </button>
      }
      <button (click)="onPageChange(currentPage + 1)" [disabled]="data.totalCount <= currentPage * maxResultCount"
        class="w-8 h-8 flex items-center justify-center rounded-lg text-xs text-gray-400 disabled:opacity-30">›</button>
      <button (click)="onPageChange(getTotalPages())" [disabled]="currentPage === getTotalPages()"
        class="w-8 h-8 flex items-center justify-center rounded-lg text-xs text-gray-400 disabled:opacity-30">»</button>
    </div>
  </div>
  }
  }

  <!-- Report Cards -->
  @if (activeTab === 'report') {
  @if (isLoading) {
  <div class="space-y-4">
    @for (i of [1,2,3]; track i) {
    <div class="h-32 bg-gray-100 rounded-2xl animate-pulse"></div>
    }
  </div>
  } @else {
  @if (reportData.length === 0) {
  <div class="py-16 text-center text-gray-400 text-sm">
    No hay datos para mostrar
  </div>
  }
  <div class="space-y-4">
    @for (item of getReportPageItems(); track item.couponCode) {
    <div class="border border-gray-200 rounded-2xl overflow-hidden bg-white shadow-sm">
      <div class="px-4 py-4">
        <!-- Fila 1: Código | Usos | Total descuento -->
        <div class="grid grid-cols-3 gap-x-2 mb-4">
          <div class="min-w-0">
            <p class="text-[10px] text-gray-400 mb-0.5">{{ '::Code' | abpLocalization }}</p>
            <p class="text-sm font-bold text-gray-900 truncate">{{ item.couponCode }}</p>
          </div>
          <div class="min-w-0">
            <p class="text-[10px] text-gray-400 mb-0.5">{{ '::UsedCount' | abpLocalization }}</p>
            <p class="text-sm font-semibold text-gray-800">{{ item.usedCount }}</p>
          </div>
          <div class="min-w-0">
            <p class="text-[10px] text-gray-400 mb-0.5">{{ '::TotalDiscount' | abpLocalization }}</p>
            <p class="text-sm font-semibold text-gray-800 truncate">{{ item.totalDiscountDisplay }}</p>
          </div>
        </div>
        <!-- Fila 2: Sommelier | Primer uso | Último uso -->
        <div class="grid grid-cols-3 gap-x-2">
          <div class="min-w-0">
            <p class="text-[10px] text-gray-400 mb-0.5">{{ '::Sommelier' | abpLocalization }}</p>
            <p class="text-[11px] font-semibold text-gray-700 truncate">{{ item.sommelierName }}</p>
          </div>
          <div class="min-w-0">
            <p class="text-[10px] text-gray-400 mb-0.5">{{ '::FirstUsed' | abpLocalization }}</p>
            <p class="text-[11px] font-semibold text-gray-700">{{ item.firstUsedDisplay || '-' }}</p>
          </div>
          <div class="min-w-0">
            <p class="text-[10px] text-gray-400 mb-0.5">{{ '::LastUsed' | abpLocalization }}</p>
            <p class="text-[11px] font-semibold text-gray-700">{{ item.lastUsedDisplay }}</p>
          </div>
        </div>
      </div>
    </div>
    }
  </div>

  <!-- Pagination -->
  @if (reportData.length > 0) {
  <div class="mt-6 flex items-center justify-between">
    <span class="text-sm font-semibold text-blue-500">{{ reportData.length }} {{ '::Total' | abpLocalization }}</span>
    <div class="flex items-center gap-1">
      <button (click)="onReportPageChange(1)" [disabled]="reportCurrentPage === 1"
        class="w-8 h-8 flex items-center justify-center rounded-lg text-xs text-gray-400 disabled:opacity-30">«</button>
      <button (click)="onReportPageChange(reportCurrentPage - 1)" [disabled]="reportCurrentPage === 1"
        class="w-8 h-8 flex items-center justify-center rounded-lg text-xs text-gray-400 disabled:opacity-30">‹</button>
      @for (p of getReportPageNumbers(); track p) {
      <button (click)="onReportPageChange(p)"
        [class]="reportCurrentPage === p ? 'bg-gray-900 text-white font-bold' : 'text-gray-500 font-medium'"
        class="w-8 h-8 flex items-center justify-center rounded-lg text-sm transition-all">
        {{ p }}
      </button>
      }
      <button (click)="onReportPageChange(reportCurrentPage + 1)"
        [disabled]="reportCurrentPage === getReportTotalPages()"
        class="w-8 h-8 flex items-center justify-center rounded-lg text-xs text-gray-400 disabled:opacity-30">›</button>
      <button (click)="onReportPageChange(getReportTotalPages())"
        [disabled]="reportCurrentPage === getReportTotalPages()"
        class="w-8 h-8 flex items-center justify-center rounded-lg text-xs text-gray-400 disabled:opacity-30">»</button>
    </div>
  </div>
  }
  }
  }

</div>